import { BaseService } from '@zaoblako/web/core/services/base.service';

import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class WarehouseService extends BaseService {
  protected baseUrl = '/basis/catalog/warehouse';

  public get dropdownDescriptorApi(): string {
    return `${this.baseUrl}/dropdown-descriptor`;
  }
}
